import { render, staticRenderFns } from "./StaffNameplate.vue?vue&type=template&id=f3f50ffa&scoped=true"
import script from "./StaffNameplate.vue?vue&type=script&lang=js"
export * from "./StaffNameplate.vue?vue&type=script&lang=js"
import style0 from "./StaffNameplate.vue?vue&type=style&index=0&id=f3f50ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f50ffa",
  null
  
)

export default component.exports